---
de:
  labels:
    apply: Anwenden
    clear: Löschen
    labels: Etiketten
